export default function getLoggedInUsersReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_LOGGEDIN_USER_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_LOGGEDIN_USER_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_LOGGEDIN_USER_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}